import React, { useEffect, useState } from 'react';
import './main.scss';
import Homepage from './Pages/Homepage/Homepage';
import Navbar from './Components/Navbar/Navbar';
import ScrollTopContext from './Contexts/ScrollTop';
import VolumeContext from './Contexts/Volume';
import LanguageContext, { LanguageType } from './Contexts/Language';
import English from './Languages/english.json';
import Polish from './Languages/polish.json';
import { useGlobalSounds } from './Sounds/Sounds';
import { Routes, Route } from 'react-router-dom';
import Start from './Pages/Start/Start';
import Credits from './Pages/Credits/Credits';
import { Analytics } from "@vercel/analytics/react"

function App() {
  const [scrollTop, setScrollTop] = useState<number>(0);
  const [volume, setVolume] = useState<number>(0);
  const [language, setLanguage] = useState<LanguageType>(localStorage.getItem("language") === "polish" ? Polish : English);

  document.body.className = `${localStorage.getItem("theme") || "dark"}-theme`;

  useGlobalSounds(volume);

  return (
    <div className="main">
      <LanguageContext.Provider value={{language, setLanguage}}>
        <VolumeContext.Provider value={{volume, setVolume}}>
          <ScrollTopContext.Provider value={{ scrollTop, setScrollTop }}>
            <Routes>
              <Route path='*' element={<Start/>} />
              <Route path='/' element={<Start/>} />
              <Route path='/homepage' element={<><Navbar/><Homepage/></>} />
              <Route path='/credits' element={<Credits/>} />
            </Routes>
          </ScrollTopContext.Provider>
        </VolumeContext.Provider>
      </LanguageContext.Provider>
      <Analytics/>
    </div>
  );
}

export default App;
